import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-security-white',
  templateUrl: './icon-security-white.component.html',
  styles: []
})
export class IconSecurityWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
